<template>
  <div>
    <Header @toggle-sidebar="toggleSidebar" />
    <div
      id="app-sidepanel"
      :class="[
        'app-sidepanel',
        isSidebarVisible ? 'sidepanel-visible' : 'sidepanel-hidden',
      ]"
    >
      <div id="sidepanel-drop" class="sidepanel-drop"></div>
      <div class="sidepanel-inner d-flex flex-column">
        <a
          href="#"
          id="sidepanel-close"
          class="sidepanel-close"
          @click.prevent="toggleSidebar"
          >&times;</a
        >
        <div class="app-branding">
          <router-link class="app-logo" :to="{ name: 'overview' }">
            <img
              class="logo-icon mr-2"
              src="assets/images/logo1.jpg"
              alt="logo"
            />
            <span class="logo-text">ADMIN PORTAL</span>
          </router-link>
        </div>
        <nav id="app-nav-main" class="app-nav app-nav-main flex-grow-1">
          <SideBar />
        </nav>
      </div>
    </div>
    <div class="app-wrapper">
      <div class="app-content pt-3 p-md-3 p-lg-4">
        <div class="">
          <!-- <h1 class="app-page-title">{{pageTitle}}</h1> -->
          <router-view />
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./Header";
import Footer from "./Footer";
import SideBar from "./SideBar.vue";
export default {
  components: { Header, Footer, SideBar },
  data() {
    return {
      pageTitle: "Page Title",
      routeName: "",
      isSidebarVisible: true,
    };
  },
  created() {
    // console.log(this.$router.history.current)
  },
  methods: {
    toggleSidebar() {
      this.isSidebarVisible = !this.isSidebarVisible;
    },
  },
  // beforeUpdate() {
  //     console.log(this.$router)
  // },
  //  beforeRouteUpdate (to, from, next) {
  //    console.log(to)
  //    console.log(from)
  //    console.log(next)
  //   }
};
</script>

<style></style>
